<section class="statics">
  <header class="statics__head">
    <h1 class="statics__title">Static - Input Values</h1>
    <p class="statics__desc">
      Maintain the static - input values for a reinsurance year. Edit a
      record's Value or Comment — each change is saved and recorded in the audit log.
    </p>
  </header>

  <div class="statics__toolbar">
    <div class="field">
      <label for="reinsuranceYear">Reinsurance Year</label>
      <p-select
        inputId="reinsuranceYear"
        [options]="years"
        [(ngModel)]="selectedYear"
        [style]="{ minWidth: '150px' }">
      </p-select>
    </div>
    <button
      pButton
      type="button"
      label="Load"
      icon="pi pi-refresh"
      [disabled]="loading"
      (click)="load()">
    </button>
  </div>

  @if (error && !editDialogVisible) {
    <p class="statics__error" role="alert">{{ error }}</p>
  }

  <div class="statics__tablewrap">
    <div class="statics__caption">
      <span class="statics__caption-title">Static values — RY {{ selectedYear }}</span>
      <span class="statics__caption-meta">{{ rows.length }} rows</span>
    </div>

    <p-table
      [value]="rows"
      [loading]="loading"
      [scrollable]="true"
      scrollHeight="520px"
      [paginator]="rows.length > 10"
      [rows]="10"
      [rowsPerPageOptions]="[10, 20, 50]"
      paginatorDropdownAppendTo="body"
      styleClass="p-datatable-sm p-datatable-gridlines">
      <ng-template pTemplate="header">
        <tr>
          <th>Measure</th>
          <th>Qtr Status</th>
          <th>Plan</th>
          <th>Fund</th>
          <th class="num">Value</th>
          <th>Comment</th>
          <th>Qtr Run Date</th>
          <th class="actions-col">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{ row.measure }}</td>
          <td>{{ row.qtrstatus }}</td>
          <td>{{ row.insuranceplanabbreviation }}</td>
          <td>{{ row.funddesignationflag }}</td>
          <td class="num">{{ formatValue(row.value) }}</td>
          <td>{{ row.comment }}</td>
          <td>{{ formatDate(row.qtrrundate) }}</td>
          <td class="actions-col">
            <button
              pButton
              type="button"
              class="p-button-text p-button-sm"
              icon="pi pi-pencil"
              label="Edit"
              (click)="openEdit(row)">
            </button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8" class="statics__empty">No static values for this selection.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>

<p-dialog
  header="Edit static value"
  [(visible)]="editDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '32rem' }"
  (onHide)="cancelEdit()">
  @if (editingRow) {
    <div class="dialog-body">
      <p class="dialog-lead">{{ editingLabel }}</p>

      <dl class="dialog-facts">
        <div><dt>Measure</dt><dd>{{ editingRow.measure }}</dd></div>
        <div><dt>Reinsurance Year</dt><dd>{{ editingRow.reinsuranceyear }}</dd></div>
        <div><dt>Plan</dt><dd>{{ editingRow.insuranceplanabbreviation }}</dd></div>
        <div><dt>Fund</dt><dd>{{ editingRow.funddesignationflag }}</dd></div>
      </dl>

      <div class="dialog-field">
        <label for="editValue">Value</label>
        <p-inputNumber
          inputId="editValue"
          [(ngModel)]="editValue"
          mode="decimal"
          [minFractionDigits]="0"
          [maxFractionDigits]="6"
          [style]="{ width: '100%' }">
        </p-inputNumber>
      </div>

      <div class="dialog-field">
        <label for="editComment">Comment</label>
        <textarea
          pTextarea
          id="editComment"
          [(ngModel)]="editComment"
          rows="3"
          [autoResize]="true">
        </textarea>
      </div>

      @if (error) {
        <p class="dialog-alert" role="alert">{{ error }}</p>
      }
    </div>
  }

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Cancel"
      class="p-button-text"
      [disabled]="saving"
      (click)="cancelEdit()">
    </button>
    <button
      pButton
      type="button"
      label="Save"
      icon="pi pi-check"
      [disabled]="saving"
      [loading]="saving"
      (click)="saveEdit()">
    </button>
  </ng-template>
</p-dialog>
